<template>
	<section class="best">
		<div class="best__title _h2">{{ $t('Top sales this week') }}</div>
		<div class="best__items">
			<SaleItem
				v-for="product in products"
				:key="product.id"
				:item="product"
				:is-auth="isAuth"
				:chosen-item="chosenItem"
				@openLoginModal="$emit('openLoginModal')"
				@addToCart="(item) => $emit('addToCart', item)"
				@openProductModal="(id) => $emit('openProductModal', id)"
				@openCartModal="$emit('openCartModal')"
			/>
		</div>
	</section>
</template>

<script>
import { mapGetters } from 'vuex';
import SaleItem from './SaleItem.vue';

export default {
	name: 'ProductCarusel',
	components: { SaleItem },
	props: {
		isAuth: {
			type: Boolean,
			required: true,
		},
		chosenItem: {
			type: String,
		},
		apiEndpoint: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			products: [],
		};
	},
	watch: {
		currencyCode() {
			this.fetchProducts();
		},
	},
	computed: {
		...mapGetters('app', ['currencyCode', 'currencySymbol']),
	},
	mounted() {
		this.fetchProducts();
	},
	methods: {
		//.get(process.env.VUE_APP_API + 'items/recommended')
		fetchProducts() {
			this.$http
				.get(process.env.VUE_APP_API + 'items/list', {
					params: {
						random: true,
						limit: 10,
					},
				})
				.then((res) => {
					const payload = Array.isArray(res.data?.payload)
						? res.data.payload
						: [];

					// cut to 3 items
					this.products = payload.slice(0, 3);
				})
				.catch((res) => {
					if (res.response.status === 401) {
						this.openSignInModal();
					}
				});
		},
		goToProduct(item) {
			this.$emit('goToProduct', item);
		},
		getTitle(title) {
			if (!title) return '';

			let part = title.split('|')[1] || title;
			part = part.split('(')[0];

			return part.trim();
		},
		getType(title) {
			if (!title) return '';

			let part = title.split('|')[0];
			part = part.replace(/^(StatTrak™|Souvenir)\s+/i, '');

			return part.trim();
		},
	},
};
</script>

<style scoped lang="scss">
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/fonts' as *;
@use '@/assets/styles/components/classes' as *;
.best {
	@include adaptiveValue('padding-top', 50, 25);
	@include adaptiveValue('padding-bottom', 110, 25);
	&__title {
		text-align: center;
		line-height: 120%;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 68, 25);
		}
	}
	&__items {
		display: flex;
		@include adaptiveValue('gap', 40, 20, 1920, 1470, 1);
		@media (max-width: $md2) {
			flex-wrap: wrap;
			justify-content: center;
		}
	}
}
</style>
